import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class ExtraBtns extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view-btn-groups">
                <button
                    className={`${(!this.props.toggle || this.props.toggle === 'all') && 'active'}`}
                    onClick={() => this.props.onChange?.('all')}
                >
                    {t('discover.algo_comparision.categories.all')}
                </button>
                <button
                    className={`${this.props.toggle === 'growth' && 'active'}`}
                    onClick={() => this.props.onChange?.('growth')}
                >
                    {t('discover.algo_comparision.categories.growth')}
                </button>
                <button
                    className={`${this.props.toggle === 'decline' && 'active'}`}
                    onClick={() => this.props.onChange?.('decline')}
                >
                    {t('discover.algo_comparision.categories.decline')}
                </button>
            </div>
        );
    }
}

export default withTranslation()(ExtraBtns);
